module.exports = __webpack_public_path__ + "static/img/mectron.a4008fe6.jpg";